<div class="prediction-table-wrap">
	<div class="table-header">{{tableHeader}}</div>
	<div class="dtc-prediction-table" [style.--col-count]="columns.length">
		<mat-accordion displayMode="flat" class="mat-table" [multi]="false">

			<section class="mat-header-row">
				<span class="toggle-spacer"></span>
				<span *ngFor="let col of columns" class="mat-header-cell">
					{{ col.label }}
				</span>
			</section>

			<mat-expansion-panel *ngFor="let row of paginatedData" [disabled]="!hasChildren(row)" hideToggle="false"> <mat-expansion-panel-header class="mat-row">
					<ng-container *ngFor="let col of columns">
						<span class="mat-cell">
							<ng-container>
								{{ row[col.key] }}
							</ng-container>
						</span>
					</ng-container>
				</mat-expansion-panel-header>

				<div class="expanded-content-wrapper">
					<section *ngFor="let child of row.children" class="mat-children-row">
						<span class="toggle-spacer"></span>
						<ng-container *ngFor="let col of columns">
							<span class="mat-cell" [ngSwitch]="col.type">
								<ng-container *ngSwitchCase="'link'">
									<a (click)="linkAction(child, row)" class="table-link">
										{{ child[col.key] }}
									</a>
								</ng-container>
								<div *ngSwitchCase="'image'" class="img-cell">
									<img *ngIf="child[col.key]" [src]="child[col.key]" alt="Row Image">
								</div>
								<span *ngSwitchDefault>
									{{ child[col.key] }}
								</span>
							</span>
						</ng-container>
					</section>
				</div>
			</mat-expansion-panel>
		</mat-accordion>
	</div>
</div>

<mat-paginator [hidden]="data.length<pageSize" class="-mat-select-height-unset common-table-mt-0"
  [length]="data.length" [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
  [showFirstLastButtons]="true" (page)="pagination($event)">
</mat-paginator>